import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {AdminLockIcon} from 'shells/icon/svg/admin-lock-icon';

import type {Permission} from 'nutshell-graphql-types';

const PERMISSIONS: Partial<
    Record<
        Permission,
        {
            label: string;
            isFixed?: boolean;
        }
    >
> = {
    CAN_ACCESS_SETUP: {label: 'Access Nutshell setup', isFixed: true},
    CAN_ACCESS_BILLING: {label: 'Access Nutshell billing'},
    CAN_ACCESS_FULL_CAMPAIGNS: {label: 'Access Nutshell’s email marketing'},
    CAN_EXPORT: {label: 'Bulk export list data'},
    CAN_BULK_EDIT: {label: 'Bulk edit list data'},
    CAN_IMPORT: {label: 'Import data'},
    CAN_MERGE_ENTITIES: {label: 'Merge companies, people, & leads'},
    CAN_DELETE_ENTITIES: {label: 'Delete companies, people, & leads'},
    CAN_ASSIGN_ENTITIES: {label: 'Reassign companies, people, & leads'},
    CAN_MANAGE_EMAIL_TEMPLATES: {label: 'Manage email templates'},
    CAN_USE_PEOPLEIQ: {label: 'Use PeopleIQ to create new contacts'},
    CAN_USE_INBOX: {label: 'Can send text messages and be assigned to threads'},
    CAN_USE_PROSPECTORIQ: {label: 'Use ProspectorIQ to create new contacts'},
    CAN_USE_SALES_DOCUMENTS: {label: 'Can create, view, and send Quotes and Invoices to leads'},
};

export function getRoleIcon(role: string): React.ComponentType<any> | null | undefined {
    switch (role) {
        case 'Admin':
            return AdminLockIcon;
        default:
            return null;
    }
}

export function getPermissions(): Partial<
    Record<
        Permission,
        {
            label: string;
            isFixed?: boolean;
        }
    >
> {
    const permissions = PERMISSIONS;

    if (!NutClientConfig.hasNutshellInboxBeta) {
        delete permissions.CAN_USE_INBOX;
    }

    return permissions;
}

export const DISABLED_PERMISSIONS: Permission[] = ['CAN_ACCESS_SETUP'];
// Previously used for fixing the can_access_crm permission. Now currently
// unused due to the removal of the can_access_crm RBAC permission.
export const FIXED_PERMISSIONS: Permission[] = [];
